module.exports = __webpack_public_path__ + "img/23.689c208e.png";